(function () {
    'use strict';

    angular.module('ib-flight-now-module').constant('FlightNowConstants', {

    });

})();